import { render, staticRenderFns } from "./ruku.vue?vue&type=template&id=29678812&scoped=true&"
import script from "./ruku.vue?vue&type=script&lang=js&"
export * from "./ruku.vue?vue&type=script&lang=js&"
import style0 from "./ruku.vue?vue&type=style&index=0&id=29678812&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29678812",
  null
  
)

export default component.exports